import { useState } from "react";
import { Form } from "reactstrap";
import { APIMS } from "../../../../../../config/apims";
import Modal from "react-bootstrap/Modal";
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import "../../../../../../index.css";
// import "../../../../../../assets/css/sims-ui.css";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";
import ToastError from "../../../../../NotificationToast/ToastError";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";

export default function ModalJenjangAdd(props) {
  const token = localStorage.getItem("token");

  const {
    GetResponseData,
    ...modalProps
  } = props;

  const [isSubmitting, setIsSubmitting] =
    useState(false);

  const [form, setForm] = useState({
    stages: "",
    stages_name: "",
    seq: "",
    min_grade: "",
    max_grade: "",
  });

  const fetchParams = {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((previousForm) => ({
      ...previousForm,
      [name]: value,
    }));
  };

  const submitMutation = useMutation(
    async () => {
      setIsSubmitting(true);

      try {
        const response = await APIMS.post(
          "/api/educational-stages/store",
          {
            stages: form.stages,
            stages_name: form.stages_name,
            seq: form.seq,
            min_grade: form.min_grade,
            max_grade: form.max_grade,
          },
          fetchParams
        );

        if (response?.status === 200) {
          ToastSuccess.fire({
            icon: "success",
            title: response.data.message,
          });

          GetResponseData();
          props.onHide();
        }
      } catch (error) {
        ToastError.fire({
          icon: "error",
          title:
            error.response?.data?.message ||
            "Gagal menyimpan data",
        });
      } finally {
        setIsSubmitting(false);
      }
    }
  );

  const handleSubmit = (event) => {
    event.preventDefault();

    if (isSubmitting) {
      return;
    }

    submitMutation.mutate();
  };

  return (
    <Modal
      {...modalProps}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="sims-modal-dialog"
      contentClassName="sims-modal-content"
      aria-labelledby="modal-tambah-jenjang"
    >
      <Form onSubmit={handleSubmit}>
        <div className="sims-modal-header">
          <div>
            <h5
              id="modal-tambah-jenjang"
              className="sims-modal-title"
            >
              Tambah Jenjang
            </h5>

          </div>

          <button
            type="button"
            className="sims-modal-close"
            onClick={props.onHide}
            disabled={isSubmitting}
            aria-label="Tutup modal"
          >
            <FontAwesomeIcon
              icon={faXmark}
            />
          </button>
        </div>

        <Modal.Body className="sims-modal-body mt-1 mx-2">
          <div className="sims-form-grid">
            <div className="sims-form-group">
              <label
                className="sims-form-label"
                htmlFor="add-stages"
              >
                Label Jenjang <span>*</span>
              </label>

              <input
                id="add-stages"
                className="sims-form-input"
                type="text"
                name="stages"
                value={form.stages}
                onChange={handleChange}
                autoFocus
                required
              />
            </div>

            <div className="sims-form-group">
              <label
                className="sims-form-label"
                htmlFor="add-seq"
              >
                Tahap Jenjang <span>*</span>
              </label>

              <input
                id="add-seq"
                className="sims-form-input"
                type="number"
                name="seq"
                value={form.seq}
                onChange={handleChange}
                inputMode="numeric"
                required
              />
            </div>

            <div className="sims-form-group sims-form-span-2">
              <label
                className="sims-form-label"
                htmlFor="add-stages-name"
              >
                Nama Jenjang <span>*</span>
              </label>

              <input
                id="add-stages-name"
                className="sims-form-input"
                type="text"
                name="stages_name"
                value={form.stages_name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="sims-form-group">
              <label
                className="sims-form-label"
                htmlFor="add-min-grade"
              >
                Kelas Awal <span>*</span>
              </label>

              <input
                id="add-min-grade"
                className="sims-form-input"
                type="number"
                name="min_grade"
                value={form.min_grade}
                onChange={handleChange}
                inputMode="numeric"
                required
              />
            </div>

            <div className="sims-form-group">
              <label
                className="sims-form-label"
                htmlFor="add-max-grade"
              >
                Kelas Akhir <span>*</span>
              </label>

              <input
                id="add-max-grade"
                className="sims-form-input"
                type="number"
                name="max_grade"
                value={form.max_grade}
                onChange={handleChange}
                inputMode="numeric"
                required
              />
            </div>
          </div>
        </Modal.Body>

        <div className="sims-modal-footer">
          <button
            type="button"
            className="sims-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="sims-modal-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="sims-button-spinner" />
                <span>Menyimpan...</span>
              </>
            ) : (
              <>
                <FontAwesomeIcon
                  icon={faFloppyDisk}
                />
                <span>Tambahkan</span>
              </>
            )}
          </button>
        </div>
      </Form>
    </Modal>
  );
}